import React from 'react'
import { FAQ } from '@primer/react-brand'
import Container from './Container'
import SectionHeader from './landing/SectionHeader'

const FAQSection = () => {
  return (
    <section id="faq" style={{ padding: '96px 0', background: 'var(--brand-color-canvas-subtle)' }}>
      <Container>
        <SectionHeader eyebrow="FAQ" heading="Questions people ask before they start." />

        <div style={{ maxWidth: '800px', marginTop: '40px' }}>
          <FAQ>
            <FAQ.Item>
              <FAQ.Question>Which platforms does CivicLens cover?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  Facebook, Instagram, TikTok, X, YouTube, LinkedIn, Threads, Bluesky, Snapchat,
                  Truth Social, Rumble, Telegram, Gab, Gettr, Weibo, Line and VK, plus podcasts and
                  Substack. Coverage grows as the needs of the people using it change.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
            <FAQ.Item>
              <FAQ.Question>What gets collected, and how often?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  Around 250,000 accounts are tracked every day, including every US politician and
                  candidate, major US media by market and platform, independent media and
                  influencers, and international news and officials. You add the accounts and search
                  terms you need on top of that, and their posts are collected on a daily cadence.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
            <FAQ.Item>
              <FAQ.Question>Is the content inside audio, video and images searchable?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  Yes. Speech in podcasts and video is transcribed and text inside images is
                  extracted, and both are indexed alongside the post itself, so you can search and
                  filter on what was actually said or shown.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
            <FAQ.Item>
              <FAQ.Question>Can I get the data out?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  Yes. Download CSVs, query the REST API, or connect your own AI agent through the
                  MCP server. Which of these your plan includes, and at what volume, is listed under
                  each plan above.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
            <FAQ.Item>
              <FAQ.Question>Who can use CivicLens?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  Journalists, researchers, academics, advocacy and civil-society organizations, and
                  other professionals working to understand online discourse. Applications are
                  reviewed to keep the platform in public-interest hands.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
            <FAQ.Item>
              <FAQ.Question>Who builds and runs it?</FAQ.Question>
              <FAQ.Answer>
                <p>
                  The Algorithmic Transparency Institute, a program of the National Conference on
                  Citizenship — a congressionally chartered nonprofit. CivicLens is developed
                  iteratively with the newsrooms, researchers and advocates who use it every day,
                  and is supported by membership fees and philanthropic funding rather than
                  advertising or data resale.
                </p>
              </FAQ.Answer>
            </FAQ.Item>
          </FAQ>
        </div>
      </Container>
    </section>
  )
}

export default FAQSection
